import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
  amend_product_status: { status: "idle" },
};

export const amend_product_status_Slice = createSlice({
  name: "amend_product_status",
  initialState,
  reducers: {
    success_amend_product_status: (state, action) => {
      state.amend_product_status = { status: app_consts.SUCCESS, data: action.payload };
    },
    fail_amend_product_status: (state, action) => {
      state.amend_product_status = { status: app_consts.FAIL, message: action.payload };
    },
    reset_amend_product_status: (state) => {
      state.amend_product_status = { status: app_consts.IDLE };
    },
    loading_amend_product_status: (state) => {
      state.amend_product_status = { status: app_consts.LOADING };
    },
  },
});

export const {
  success_amend_product_status,
  fail_amend_product_status,
  reset_amend_product_status,
  loading_amend_product_status,
} = amend_product_status_Slice.actions;

export default amend_product_status_Slice.reducer;
